import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-request-submitted',
  templateUrl: './request-submitted.component.html',
  styleUrls: ['./request-submitted.component.scss']
})
export class RequestSubmittedComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
